import { render, staticRenderFns } from "./PageTechRequirements.vue?vue&type=template&id=95d60a66&scoped=true&"
import script from "./PageTechRequirements.vue?vue&type=script&lang=js&"
export * from "./PageTechRequirements.vue?vue&type=script&lang=js&"
import style0 from "./PageTechRequirements.vue?vue&type=style&index=0&id=95d60a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d60a66",
  null
  
)

export default component.exports